import DispatchConstants from '../constants/DispatchConstants';

import { HelpCategory, HelpTopic } from '../model/HelpTopics';

import type { HelpCategoryProps, HelpTopicProps } from '../model/HelpTopics';

const initState = () => ({
  selectedHelpCategory: HelpCategory(),
  selectedHelpTopic: HelpTopic(),
});

const submitRequest = (
  state = initState(),
  action: { type?: string; payload?: HelpCategoryProps | HelpTopicProps } = {},
) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_SELECTED_HELP_CATEGORY:
      if (!payload) {
        return state;
      }

      return { ...state, selectedHelpCategory: payload as HelpCategoryProps };

    case DispatchConstants.UPDATE_SELECTED_HELP_TOPIC:
      if (!payload) {
        return state;
      }

      return { ...state, selectedHelpTopic: payload as HelpTopicProps };

    default:
      return state;
  }
};

export default submitRequest;
